import { FeatureFlag, useFeatureFlags } from "contexts/FeatureFlagContext";

const useFeatureFlag = (flag: FeatureFlag): boolean => {
  const { hasFlag } = useFeatureFlags();
  return hasFlag(flag);
};

export default useFeatureFlag;
